//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      ...(this.$route && this.$route.meta && this.$route.meta.headerBack
        ? this.$route.meta.headerBack
        : {}),
      hasScrolled: false,
    }
  },
  computed: {
    title() {
      return this.$translation('menu.' + this.$route.meta.name)
    },
    editProfileUrl() {
      return this.editButton
        ? '/user/' + this.$auth.user.nickname + '/edit-profile'
        : null
    },
    editButton() {
      return (
        this.showEditButton &&
        this.$auth.user &&
        this.$auth.user.nickname === this.$route.params.user
      )
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goBack() {
      if (this.$auth.user) {
        this.$router.push({
          path: this.$localeResolver.localePath(this.backUrl),
        })
      } else {
        this.$router.go(-1)
      }
    },
    handleScroll() {
      this.hasScrolled = window.scrollY > 0
    },
  },
}
